import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/views/Home.vue';
import Login from '@/views/Login.vue';
import Register from '@/views/Register.vue';
import Assignments from '@/views/Assignments.vue';
import Schedule from '@/views/Schedule.vue';

import * as firebase from "firebase/app";
import "firebase/auth";

Vue.use(Router);


export const router = new Router({
    mode: 'history',
    routes: [
        { name: "home", path: '/', component: Home },
        { name: "login", path: '/login', component: Login },
        { name: "register", path: '/register', component: Register },
        { name: "assignments", path: '/assignments', component: Assignments, meta: { requiresAuth: true } },
        { name: "schedule", path: '/schedule', component: Schedule, meta: { requiresAuth: true } },
        { name: "catch_all", path: '*', component: Home }
    ]

});


router.beforeEach((to, from, next) => {
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
    const isAuthenticated = firebase.auth().currentUser;
    // console.log("isauthenticated", isAuthenticated);
    if (requiresAuth && !isAuthenticated) {
        // console.log("router guard: login");
        next("/home");
    } else {
        next();
    }
});

